module.exports = __webpack_public_path__ + "static/media/hearts.bed7cd8b.svg";